import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import $ from 'jquery';
import Preview from './Preview';
import ProgressBar from '../../../../view/ProgressBar';
import {ContractCreate} from '../../../../view/Messages';
import Data from '../../../../data/StateRealEstateMortgage.json';
import converter from 'number-to-words';
import FormGuarantee from '../../../../view/FormGuarantee';
import {Title, Noun, UnCurrency, SubjectVerb, Pronoun} from '../../../../model/Helper';
import Loading from '../../../../view/Loading';
import PaperSignatoriesForPdf from '../../../../model/PaperSignatoriesForPdf';
import PaperSignatoriesAcknowledgementForPdf from '../../../../model/PaperSignatoriesAcknowledgementForPdf';
import RequiredData from '../../../../model/RequiredData';
import PaperPartyPdf from '../../../../model/PaperPartyPdf';
import FormFinal from '../../../../view/FormFinal';
import Meta from '../../../../model/Meta';

class RealEstateMortgageStep6 extends Component {

    constructor(props){
        super(props);
        this.state = Data;
    }

    componentWillMount() {
        if(localStorage.getItem(this.state.formId)===null) {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}

		let data = JSON.parse(localStorage.getItem(this.state.formId));

		if(data){
			this.setState({
				details: data.details
			},			
				()=>{
                    RequiredData.property(this.state, this.state.formPath+"/1");
                    RequiredData.registryOfDeeds(this.state, this.state.formPath+"/1");
                    RequiredData.mortgagor(this.state, this.state.formPath+"/2");
                    RequiredData.mortgagee(this.state, this.state.formPath+"/3");
                    RequiredData.realEstateMortgage4(this.state, this.state.formPath+"/4");
                    RequiredData.realEstateMortgage5(this.state, this.state.formPath+"/5");

					//console.log("State default: ", this.state);
					localStorage.setItem(this.state.formId, JSON.stringify(this.state));

				}
			);
		} else {
			localStorage.setItem(this.state.formId, JSON.stringify(this.state));
		}
    }

    componentDidMount() {
		$('html, body').animate({scrollTop: 0}, 300);
	}

    handleChange(event) {
		const target = event.target;
	    const value = target.type === 'checkbox' ? target.checked : target.value;

	    this.setState({
			destinationEmail: value
		}, ()=>{
			let regex =/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			if(regex.test(value)) {
				$(".download").addClass("btn-success").prop("disabled", false);
				$(".form-text").addClass("d-none");
			} else {
				$(".download").removeClass("btn-success").prop("disabled", true);
				$(".form-text").removeClass("d-none");
			}
		});
	}

    render() {
        // Data
        let p = this.state.details.property;
        let s = this.state.details.mortgagor;
        let b = this.state.details.mortgagee;

        /**
         * Noun / Pronoun
         */
        let nounMortgagor = Noun(s, "mortgagor");
        let nounMortgagee  = Noun(b, "mortgagee");

        let blankLine = "____________________";

        let title = (Title(p)) ? Title(p) : blankLine;
        let pAddress = (p.address) ? p.address : blankLine;
        let pType = blankLine;
        if(p.type==="Condominium"){
            pType = `condominium`;
        }
        if(p.type==="Land"){
            pType = `parcel of land`;
        }
        if(p.type==="Land with Improvement"){
            pType = `parcel of land, together with its improvement`;
        }
        let registryOfDeeds = p.registryOfDeeds ? p.registryOfDeeds : blankLine;
        let loanAmount = p.loanAmount ? UnCurrency(p.loanAmount) : 0;
        let loanAmountText = (typeof parseFloat(loanAmount) === "number" && parseFloat(loanAmount)>0) ?
        converter.toWords(loanAmount) : 
        blankLine;
        let loanAmountNumber = (typeof parseFloat(loanAmount) === "number" && parseFloat(loanAmount)>0) ?
        Number(loanAmount).toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2}) :
        blankLine;
        let loanInterestBasis = p.loanInterestBasis ? p.loanInterestBasis : blankLine;
        let loanInterestRate = p.loanInterestRate ? p.loanInterestRate : blankLine;
        let loanInterestRateText = (typeof parseFloat(loanInterestRate) === "number" && parseFloat(loanInterestRate)>0) ?
        converter.toWords(loanInterestRate) : 
        blankLine;
        let loanDuration = p.loanDuration ? p.loanDuration : blankLine;

        let loanDurationInMonthsNumber = loanDuration*12;
        let loanDurationInMonthsText = converter.toWords(loanDurationInMonthsNumber);
        //let registrationType = p.registrationType ? p.registrationType : blankLine;
        let registerMortgageBy = p.registerMortgageBy ? p.registerMortgageBy : blankLine;
        let requireFireInsurance = p.requireFireInsurance;
        let registerMortgage = p.registerMortgage;
        let paymentFees = p.paymentFees;
        let paymentDefault = p.paymentDefault;
        let paymentDefaultText = converter.toWords(paymentDefault);

        let sectionDeduct = (requireFireInsurance==="Yes" ? 1 : 0) + (registerMortgage==="Yes" ? 1 : 0);

        // Natural person variables
        let mortgagorName = [], 
            mortgagorSpouseName = [],
            mortgagorNationality = [],
            mortgagorAddress = [],
            mortgagorRepresentativeName = [],
            mortgagorRepresentativeNationality = [],
            mortgagorRepresentativeAddress = [],
            mortgagorTin = [];
        // Corporation variables
        let mortgagorCorporationName = [],
            mortgagorCorporationPrincipalPlaceOfBusiness = [],
            mortgagorCorporationRepresentativeName = [],
            mortgagorCorporationRepresentativePosition = [],
            mortgagorCorporationTin = [];
        s.forEach((mortgagor, i)=>{
            mortgagorName[i] = (mortgagor.mortgagorFname || mortgagor.mortgagorMname || mortgagor.mortgagorLname) ? 
                                    (mortgagor.mortgagorFname+(mortgagor.mortgagorMname?` ${mortgagor.mortgagorMname}`:"")+(mortgagor.mortgagorLname?` ${mortgagor.mortgagorLname}`:"")+(mortgagor.mortgagorSuffix?` ${mortgagor.mortgagorSuffix}`:"")): 
                                    blankLine;
            mortgagorSpouseName[i] = (mortgagor.mortgagorSpouseFname || mortgagor.mortgagorSpouseMname || mortgagor.mortgagorSpouseLname) ? 
            (mortgagor.mortgagorSpouseFname+(mortgagor.mortgagorSpouseMname?` ${mortgagor.mortgagorSpouseMname}`:"")+(mortgagor.mortgagorSpouseLname?` ${mortgagor.mortgagorSpouseLname}`:"")+(mortgagor.mortgagorSpouseSuffix?` ${mortgagor.mortgagorSpouseSuffix}`:"")): 
            blankLine;
            mortgagorNationality[i] = mortgagor.mortgagorNationality ? mortgagor.mortgagorNationality : blankLine;
            mortgagorAddress[i] = mortgagor.mortgagorAddress ? mortgagor.mortgagorAddress :  blankLine;
            
            mortgagorRepresentativeName[i] = (mortgagor.mortgagorRepresentativeFname || mortgagor.mortgagorRepresentativeMname || mortgagor.mortgagorRepresentativeLname) ? 
                                    (mortgagor.mortgagorRepresentativeFname+(mortgagor.mortgagorRepresentativeMname?` ${mortgagor.mortgagorRepresentativeMname}`:"")+(mortgagor.mortgagorRepresentativeLname?` ${mortgagor.mortgagorRepresentativeLname}`:"")+(mortgagor.mortgagorRepresentativeSuffix?` ${mortgagor.mortgagorRepresentativeSuffix}`:"")): 
                                    blankLine;
            mortgagorRepresentativeNationality[i] = mortgagor.mortgagorRepresentativeNationality ? mortgagor.mortgagorRepresentativeNationality : blankLine;
            mortgagorRepresentativeAddress[i] = mortgagor.mortgagorRepresentativeAddress ? mortgagor.mortgagorRepresentativeAddress :  blankLine;
            mortgagorTin[i] = mortgagor.mortgagorTin ? mortgagor.mortgagorTin : "";

            mortgagorCorporationName[i] = mortgagor.mortgagorCorporationName ? mortgagor.mortgagorCorporationName : blankLine;
            mortgagorCorporationPrincipalPlaceOfBusiness[i] = mortgagor.mortgagorCorporationPrincipalPlaceOfBusiness ? mortgagor.mortgagorCorporationPrincipalPlaceOfBusiness : blankLine;
            
            mortgagorCorporationRepresentativeName[i] = (mortgagor.mortgagorCorporationRepresentativeFname || mortgagor.mortgagorCorporationRepresentativeMname || mortgagor.mortgagorCorporationRepresentativeLname) ? 
                                    (mortgagor.mortgagorCorporationRepresentativeFname+(mortgagor.mortgagorCorporationRepresentativeMname?` ${mortgagor.mortgagorCorporationRepresentativeMname}`:"")+(mortgagor.mortgagorCorporationRepresentativeLname?` ${mortgagor.mortgagorCorporationRepresentativeLname}`:"")+(mortgagor.mortgagorCorporationRepresentativeSuffix?` ${mortgagor.mortgagorCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            mortgagorCorporationTin[i] = mortgagor.mortgagorCorporationTin ? mortgagor.mortgagorCorporationTin : "";
            mortgagorCorporationRepresentativePosition[i] = mortgagor.mortgagorCorporationRepresentativePosition ? mortgagor.mortgagorCorporationRepresentativePosition : blankLine;
        });

        // Natural person variables
        let mortgageeName = [], 
            mortgageeSpouseName = [],
            mortgageeNationality = [],
            mortgageeAddress = [],
            mortgageeRepresentativeName = [],
            mortgageeRepresentativeNationality = [],
            mortgageeRepresentativeAddress = [],
            mortgageeTin = [];
        // Corporation variables
        let mortgageeCorporationName = [],
            mortgageeCorporationPrincipalPlaceOfBusiness = [],
            mortgageeCorporationRepresentativeName = [],
            mortgageeCorporationRepresentativePosition = [];
        b.forEach((mortgagee, i)=>{
            mortgageeName[i] = (mortgagee.mortgageeFname || mortgagee.mortgageeMname || mortgagee.mortgageeLname) ? 
                                    (mortgagee.mortgageeFname+(mortgagee.mortgageeMname?` ${mortgagee.mortgageeMname}`:"")+(mortgagee.mortgageeLname?` ${mortgagee.mortgageeLname}`:"")+(mortgagee.mortgageeSuffix?` ${mortgagee.mortgageeSuffix}`:"")): 
                                    blankLine;
            mortgageeSpouseName[i] = (mortgagee.mortgageeSpouseFname || mortgagee.mortgageeSpouseMname || mortgagee.mortgageeSpouseLname) ? 
            (mortgagee.mortgageeSpouseFname+(mortgagee.mortgageeSpouseMname?` ${mortgagee.mortgageeSpouseMname}`:"")+(mortgagee.mortgageeSpouseLname?` ${mortgagee.mortgageeSpouseLname}`:"")+(mortgagee.mortgageeSpouseSuffix?` ${mortgagee.mortgageeSpouseSuffix}`:"")): 
            blankLine;
            mortgageeNationality[i] = mortgagee.mortgageeNationality ? mortgagee.mortgageeNationality : blankLine;
            mortgageeAddress[i] = mortgagee.mortgageeAddress ? mortgagee.mortgageeAddress :  blankLine;
            
            mortgageeRepresentativeName[i] = (mortgagee.mortgageeRepresentativeFname || mortgagee.mortgageeRepresentativeMname || mortgagee.mortgageeRepresentativeLname) ? 
                                    (mortgagee.mortgageeRepresentativeFname+(mortgagee.mortgageeRepresentativeMname?` ${mortgagee.mortgageeRepresentativeMname}`:"")+(mortgagee.mortgageeRepresentativeLname?` ${mortgagee.mortgageeRepresentativeLname}`:"")+(mortgagee.mortgageeRepresentativeSuffix?` ${mortgagee.mortgageeRepresentativeSuffix}`:"")): 
                                    blankLine;
            mortgageeRepresentativeNationality[i] = mortgagee.mortgageeRepresentativeNationality ? mortgagee.mortgageeRepresentativeNationality : blankLine;
            mortgageeRepresentativeAddress[i] = mortgagee.mortgageeRepresentativeAddress ? mortgagee.mortgageeRepresentativeAddress :  blankLine;

            mortgageeCorporationName[i] = mortgagee.mortgageeCorporationName ? mortgagee.mortgageeCorporationName : blankLine;
            mortgageeCorporationPrincipalPlaceOfBusiness[i] = mortgagee.mortgageeCorporationPrincipalPlaceOfBusiness ? mortgagee.mortgageeCorporationPrincipalPlaceOfBusiness : blankLine;
            
            mortgageeCorporationRepresentativeName[i] = (mortgagee.mortgageeCorporationRepresentativeFname || mortgagee.mortgageeCorporationRepresentativeMname || mortgagee.mortgageeCorporationRepresentativeLname) ? 
                                    (mortgagee.mortgageeCorporationRepresentativeFname+(mortgagee.mortgageeCorporationRepresentativeMname?` ${mortgagee.mortgageeCorporationRepresentativeMname}`:"")+(mortgagee.mortgageeCorporationRepresentativeLname?` ${mortgagee.mortgageeCorporationRepresentativeLname}`:"")+(mortgagee.mortgageeCorporationRepresentativeSuffix?` ${mortgagee.mortgageeCorporationRepresentativeSuffix}`:"")): 
                                    blankLine;
            mortgageeTin[i] = mortgagee.mortgageeTin ? mortgagee.mortgageeTin : "";  
            mortgageeCorporationRepresentativePosition[i] = mortgagee.mortgageeCorporationRepresentativePosition ? mortgagee.mortgageeCorporationRepresentativePosition : blankLine; 
        });

        let contract_html = `
        <style type="text/css">
            @import url("./css/styles.css");
            @import url("./css/styles-custom.css");
        </style>
        <div class="pdf">
            <div class="paper">
                
                <div class="paper-title text-center">
                    Real Estate Mortgage
                </div>

                <div class="text-uppercase">
                    <p class="no-indent">
                        KNOW ALL MEN BY THESE PRESENTS:
                    </p>
                </div>

                <div>
                    <p>
                        This Real Estate Mortgage (hereinafter "REM"), is made and entered into by and between:
                    </p>
                </div>

                <div class="my-3">
                    ${PaperPartyPdf(s, "mortgagor")}
                </div>

                <div class="paper-narrow my-3 text-center">
                    <div class="my-3">- and -</div>
                </div>

                <div class="my-3">
                    ${PaperPartyPdf(b, "mortgagee")}
                </div>

                <div class="paper-narrow my-3 text-center">
                    <div class="my-3"><strong>WITNESSETH</strong>: That-</div>
                </div>

                <div>
                    <p>
                        WHEREAS, the <span class="text-uppercase">${nounMortgagor}</span> are the absolute and registered owners of a ${pType} (hereinafter “Subject Real Property”), situated at <span class="dynamic-data text-capitalize">${pAddress}</span> and covered by <span class="dynamic-data text-uppercase">${title}</span> of the Registry of Deeds for <span class="dynamic-data text-capitalize">${registryOfDeeds}</span>.
                    </p>
                </div>
                        
                <div>
                    <p>
                        WHEREAS, the <span class="text-uppercase">${nounMortgagor}</span> is indebted to the <span class="text-uppercase">${nounMortgagee}</span> in the principal sum of <span class="dynamic-data text-uppercase">${loanAmountText}</span> PESOS (P<span class="dynamic-data">${loanAmountNumber}</span>), Philippine Currency, under and by virtue of a Promissory Note (hereinafter “Note”) attached herewith and made an integral part hereof;   
                    </p>
                </div>

                <div>
                    <p>
                        WHEREAS, the <span class="text-uppercase">${nounMortgagor}</span> ${SubjectVerb(nounMortgagor, "has")} agreed to secure the payment of the Note to the <span class="text-uppercase">${nounMortgagee}</span> by means of a good and valid mortgage upon the Subject Real Property as described in <span class="dynamic-data text-uppercase">${title}</span>, a copy of which is hereto attached and made an integral part hereof;  
                    </p>
                </div>

                <div>
                    <p>
                        NOW THEREFORE, for and in consideration of the foregoing premises and as security for payment of the aforesaid obligation, the <span class="text-uppercase">${nounMortgagor}</span> ${SubjectVerb(nounMortgagor, "has")}  transferred and conveyed, and by these presents transfer and convey by way of MORTGAGE, unto the <span class="text-uppercase">${nounMortgagee}</span>, ${Pronoun("his", s[0].mortgageeGender, s[0].legalPersonality, nounMortgagee)} heirs, successors or assigns the aforesaid Subject Real Property under the terms and conditions specified below:
                    </p>
                </div>

                <div class="section1 my-3">
                    <h5 class="my-3">SECTION 1. <u>PAYMENT AND INTEREST</u></h5>
                    <p>
                        The principal obligation secured by this mortgage shall be <span class="dynamic-data text-uppercase">${loanAmountText}</span> PESOS (P<span class="dynamic-data">${loanAmountNumber}</span>), plus interest of <span class="dynamic-data text-uppercase">${loanInterestRateText}</span> percent (%<span class="dynamic-data">${loanInterestRate}</span>) per <span class="dynamic-data">${loanInterestBasis==="Monthly"?`month`:`year`}</span> on the principal, for a duration of <span class="dynamic-data">${loanDurationInMonthsText}</span> (<span class="dynamic-data">${loanDurationInMonthsNumber}</span>) months; the particulars of this loan obligation are described on the Note hereto attached.
                    </p> 
                </div>

                <div class="section2 my-3">
                    <h5 class="my-3">SECTION 2. <u>TAXES AND ASSESSMENT</u></h5>
                    <p>
                        The <span class="text-uppercase">${nounMortgagor}</span> shall, when due, pay to the government the real property taxes and such special assessments, if any, that may be levied on the mortgaged property, presenting to the <span class="text-uppercase">${nounMortgagee}</span> upon demand the receipt or evidence of payment; and in case of delinquency on the part of said <span class="text-uppercase">${nounMortgagor}</span>, the <span class="text-uppercase">${nounMortgagee}</span> may at ${Pronoun("his", s[0].mortgageeGender, s[0].legalPersonality, nounMortgagee)} option pay all such taxes and penalties, provided that the amount so paid shall be charged against the <span class="text-uppercase">${nounMortgagor}</span> with legal interest thereon, and the same shall be deemed to be guaranteed likewise by the present mortgage.
                    </p>
                </div>

                <div class="section3 my-3">
                    <h5 class="my-3">SECTION 3. <u>REPAIRS AND PRESERVATION</u></h5>
                    <p>
                        That, with a view to preserving the condition of the buildings and improvements covered by this mortgage, the <span class="text-uppercase">${nounMortgagor}</span> agrees to undertake the necessary repairs thereon, when so required by the <span class="text-uppercase">${nounMortgagee}</span>, the latter reserving the right to inspect personally or through representative the premises from time to time to verify the existing conditions.
                    </p>
                </div>

                <div class=${requireFireInsurance==="Yes"?``:`d-none`}>
                    <div class="section4 my-3">
                        <h5 class="my-3">SECTION 4. <u>INSURANCE</u></h5>
                        <p>
                            The <span class="text-uppercase">${nounMortgagor}</span> binds himself to insure the improvements covered by this mortgage against fire with a reputable insurance company acceptable to the <span class="text-uppercase">${nounMortgagee}</span> for a sum of not less than the principal obligation herein secured, endorsing the corresponding insurance policy in favor of the <span class="text-uppercase">${nounMortgagee}</span> to the extent of the latter’s interest; provided, however, that in case of failure on the part of the <span class="text-uppercase">${nounMortgagor}</span> to pay in due time the insurance premium, the <span class="text-uppercase">${nounMortgagee}</span> reserves the right to effect payment and charge the amount against the <span class="text-uppercase">${nounMortgagor}</span> with legal interest thereon, and this obligation shall be deemed to be also guaranteed by the present mortgage.
                        </p>
                    </div>
                </div>

                <div class=${registerMortgage==="Yes"?``:`d-none`}>
                    <div class="section5 my-3">
                        <h5 class="my-3">SECTION 5. <u>REGISTRATION</u></h5>
                        <p>
                            This REM shall be registered before the Office of the Register of Deeds for the purpose of having the same annotated on the title of the Subject Real Property. The fee for its registration shall be for the account of the <span class="dynamic-data text-uppercase">${registerMortgageBy}</span>.
                        </p>    
                    </div>
                </div>

                <div class="section6 my-3">
                    <h5 class="my-3">SECTION ${4 + sectionDeduct}. <u>OTHER INCIDENTAL EXPENSES</u></h5>
                    <p>
                        The cost of documentary stamps, including the notarial fee and other expenses in connection with the preparation of this REM and such other legal document as may be required shall be for the account of the <span class="dynamic-data text-uppercase">${paymentFees}</span>.
                    </p>    
                </div>

                <div class="section7 my-3">
                    <h5 class="my-3">SECTION ${5 + sectionDeduct}. <u>POSSESSION OF THE OWNER'S DUPLICATE ORIGINAL TITLE</u></h5>
                    <p>
                        Upon execution of this REM, the <span class="text-uppercase">${nounMortgagor}</span> shall surrender possession of the Owner’s Duplicate Original Title in favor of the <span class="text-uppercase">${nounMortgagee}</span>. The same shall only be given back upon discharge of the mortgage.
                    </p>    
                </div>

                <div class="section8 my-3">
                    <h5 class="my-3">SECTION ${6 + sectionDeduct}. <u>BREACH OF CONTRACT</u></h5>
                    <p>
                        Any violation on the part of the <span class="text-uppercase">${nounMortgagor}</span> of any of the conditions herein stipulated, including the non-payment when due of any stipulated amortizations, or the interest on the principal obligation, for <span class="dynamic-data">${paymentDefaultText} (${paymentDefault})</span> consecutive months, shall be deemed sufficient ground for the immediate foreclosure of this mortgage to recover the whole amount when remaining unpaid and outstanding, the period hereinabove stipulated notwithstanding.    
                    </p>    
                </div>

                <div class="section9 my-3">
                    <h5 class="my-3">SECTION ${7 + sectionDeduct}. <u>SPECIAL POWER OF ATTORNEY</u></h5>
                    <p>
                        In case of foreclosure, the <span class="text-uppercase">${nounMortgagee}</span> may elect to proceed either judicially or extrajudicially, and in the latter event, it shall be, as it is hereby appointed attorney-infact of the <span class="text-uppercase">${nounMortgagor}</span>, among other things, to take possession of the mortgaged property, to collect the fruits and rents therefrom, and to sell the mortgaged property at public auction in accordance with the procedure described in Act 3135, as amended by Act 4118, for the satisfaction of all the obligations secured by this mortgage, including reasonable attorney’s fees for the enforcement thereof and liquidated damages in an amount equivalent to ten percent (10%) of all such obligations as may then be due and outstanding, but in no case to be less than ONE HUNDRED THOUSAND PESOS (P100,000.00), apart from cost and legal expenses prescribed by the Rules of Court; as in case of judicial foreclosure, the <span class="text-uppercase">${nounMortgagee}</span>, shall be entitled as a matter of right to the appointment of a receiver of the mortgaged property, with the necessary authority appertaining to such position.   
                    </p>    
                </div>

                <div class="section10 my-3">
                    <h5 class="my-3">SECTION ${8 + sectionDeduct}. <u>BIDDER AT PUBLIC AUCTION</u></h5>
                    <p>
                        The <span class="text-uppercase">${nounMortgagee}</span> or ${Pronoun("his", s[0].mortgageeGender, s[0].legalPersonality, nounMortgagee)} representative may participate as bidder at the auction sale of the mortgaged property, whether under judicial foreclosure proceedings or under the special power of sale herein provided, or otherwise:  
                    </p> 
                    <div class="ml-5">   
                        <ol type="a">
                            <li>
                                To the payment of expenses and cost of foreclosure sale, including publication, and attorney’s fees as herein provided, as well as liquidated damages;
                            </li>
                            <li>
                                To the satisfaction of all interest and charges accruing upon the obligations herein secured;
                            </li>
                            <li>
                                To the satisfaction of the amount of the principal obligation secured by the mortgage;
                            </li>
                            <li>
                                To the satisfaction of all further obligations owing by the <span class="text-uppercase">${nounMortgagor}</span> or other lienholders; and
                            </li>
                            <li>
                                The residue, if any, to be turned over to the <span class="text-uppercase">${nounMortgagor}</span>.
                            </li>
                        </ol>
                    </div>
                </div>

                <div class="section11 my-3">
                    <h5 class="my-3">SECTION ${9 + sectionDeduct}. <u>DISCHARGE OF MORTGAGE</u></h5>
                    <p>
                        It is the principal condition of this mortgage that if the <span class="text-uppercase">${nounMortgagor}</span> shall pay or cause to be paid to the <span class="text-uppercase">${nounMortgagee}</span> or ${Pronoun("his", s[0].mortgageeGender, s[0].legalPersonality, nounMortgagee)} heirs or assigns, the principal obligation herein secured, together with the interest thereon, and the other obligations arising thereunder, when the same shall have become due and payable, and shall comply faithfully with all the other conditions stipulated herein, then this mortgage <span class="font-italic">shall ipso</span> facto become null and void; otherwise, it shall remain in full force and effect and be enforceable in the manner provided by law and by this agreement.
                    </p>
                </div>
                
                <br />

                <div>
                    <p>
                        IN WITNESS WHEREOF, the parties have hereunto set their hands this _______________ at _______________.
                    </p>
                </div>

                <br />

                <div>
                    ${PaperSignatoriesForPdf(s, b)}
                </div>

                <br />
                <br />
                <br />

                <div class="mt-5">
                    <div>
                        Signed in the presence of:
                    </div>
                    <table class="table-even mt-5">
                        <tr>
                            <td class="text-center">
                                <div class="blank-line-long "></div>
                            </td>
                            <td class="text-center">
                                <div class="blank-line-long "></div>
                            </td>
                        </tr>
                    </table>
                </div>


            </div>

            <div class="paper" style="page-break-before: always;">
                
                <table class="table-even">
                    <tr>
                        <td>
                            <table>
                                <tr><td><div class="pr-25px">REPUBLIC OF THE PHILIPPINES )</div></td></tr>
                                <tr><td><div class="text-right">)S.S.</div></td></tr>
                            </table>
                        </td>
                        <td>
                        </td>
                    </tr>
                </table>

                <div class="paper-title text-center">
                    Acknowledgement
                </div>

                <div>
                    <p>
                        BEFORE ME, a Notary Public for and in the above jurisdiction, this _______________, personally appeared the following:
                    </p>
                </div>

                ${PaperSignatoriesAcknowledgementForPdf(s, b)}

                <div>
                    <p>
                        Known to me and to me known to be the same persons who executed the foregoing Real Estate Mortgage (REM) consisting of [PAGES] pages, including this page where the acknowledgment is written, signed by the parties on each and every page hereof, and acknowledged to me that the same is their free and voluntary act and deed.
                    </p>
                    <p>
                        WITNESS MY HAND AND SEAL in the place and on the date first above written.
                    </p>
                </div>

                <br />
                <br />
                <div class="docno">
                    Doc No. ________; <br />
                    Page No. _______; <br />
                    Book No. _______; <br />
                    Series of 20 ___. <br />
                </div>	

            </div>
        </div>`;

        let fn = "real_estate_mortgage_contracts_ph_"+Date.now();
        let dn = this.state.formName;

        const meta = {
			title: "Your Real Estate Mortgage Contract is ready",
			description: "Your custom Real Estate Mortgage Contract is now ready for download"
		}
        
        return(
            <div className="page page-inner page-contract">
                <Meta {...meta}/>
                <Loading />
				<div className="">
					<div className="">					
						<div className="row">
							<div className="col-12 col-md-5">
								<h4 className="page-title pt-0 pb-3">{this.state.formName}</h4>
                                <ContractCreate />
                                <ProgressBar percentage={Math.floor((6/6)*100)} />

                                {/* Final step starts here */}
                                <div className="my-5 text-center">
                                    <FormFinal 
                                        contract_html={contract_html} 
                                        fn={fn} 
                                        dn={dn} 
                                        formPath={this.state.formPath}
                                        details={this.state.details} />
                                </div>

								<FormGuarantee />

								<div className="nav-step mt-4">
									<p className="p-0 m-0">Step 6/6</p>
									<Link to={this.state.formPath+"/5"} className="btn btn-lightblue mr-2">Go Back and Edit</Link>
								</div>

                            </div>
                            <div className="col-12 col-md-7 right-preview">
                                <Preview {...this.state} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default RealEstateMortgageStep6;


// WEBPACK FOOTER //
// ./src/pages/contracts/real-estate/real-estate-mortgage/RealEstateMortgageStep6.js